import Vue from 'vue';
import './registerServiceWorker';
import router from './router';

import { VueDiContainer } from 'vue-di-container';
import coreUI from '@moj/core-ui';
// Plugins
import i18n from '@/plugins/i18n';
import vuetify from '@/plugins/vuetify';
import initializeApplication from '@/plugins/application-initialization';
// Components
import App from './views/App/app';
// styles
import '../public/styles/main.scss';
import AxiosService from './services/axios';
import LoaderService from './services/loader';
import { DatePlugin } from './plugins/date';

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.use(VueDiContainer);
Vue.use(coreUI);
Vue.use(DatePlugin);
declare module 'vue/types/vue' {
  interface Vue {
    $appInsights: any;
  }
}

declare global {
  interface Window {
    $config: any;
    $disableNewRequestsPeriod: any;
    showLoader(): void;
    hideLoader(): void;
  }
}

initializeApplication().then(() => {
  new Vue({
    i18n,
    router,
    vuetify,
    diProvide: [
      AxiosService,
      LoaderService,
    ],
    render: (h) => h(App),
  }).$mount('#app');
});
